/* eslint-disable max-statements */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchIds: string[];
}

export const useDownloadBulkBatchesReport = () => {
  return useMutation({
    mutationFn: async ({ batchIds }: HookProps) => {
      const response = await request(
        {
          path: 'batches/download-bulk-batches-report',
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: { batchIds },
        },
        true,
      );

      const binaryData = [];
      binaryData.push(response.data);
      const href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }));
      const link = document.createElement('a');
      link.href = href;

      const [, fileName] = response.headers['content-disposition'].match(/attachment; filename="(.*)"/i);

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded bulk batch reports!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading bulk batch reports!');
    },
  });
};
